import { CLICK, MAP_MOVE, RIGHT_CLICK } from './baseEvents'

const GLOBAL_MAP = 'Global Map'

export const GLOBAL_MAP_MOVE = `${MAP_MOVE} ${GLOBAL_MAP}`
export const GLOBAL_MAP_CLUSTER_RIGHT_CLICK = `${RIGHT_CLICK} ${GLOBAL_MAP} - Cluster`
export const GLOBAL_MAP_CLUSTER_CLICK = `${CLICK} ${GLOBAL_MAP} - Cluster`
export const GLOBAL_MAP_FACILITY_MARKER_CLICK = `${CLICK} ${GLOBAL_MAP} - Facility Marker`
export const GLOBAL_MAP_INCIDENT_MARKER_CLICK = `${CLICK} ${GLOBAL_MAP} - Incident Marker`
export const GLOBAL_MAP_CIRCULAR_MENU_ITEM_CLICK = `${CLICK} ${GLOBAL_MAP} - Circular Menu Item`
